// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Kazakhstan from '../_raw/flag/icon_flag_kazakhstan.png';

export default () => <img src={Kazakhstan} alt="Kazakhstan" />;
